import React from 'react';
import { sumMapsAcrossDays } from './aggregations';

export default function FlagFiringRate({ dailyDocs = [] }) {
    const agg = sumMapsAcrossDays(dailyDocs, 'by_red_flag');
    const top5 = Object.entries(agg).sort(([, a], [, b]) => b - a).slice(0, 5);
    if (top5.length === 0) {
        return (
            <section className="dashboard-section">
                <h3>Top firing flags (30d)</h3>
                <p className="dashboard-empty">No flags fired in the last 30 days.</p>
            </section>
        );
    }
    return (
        <section className="dashboard-section">
            <h3>Top firing flags (30d)</h3>
            <ul className="flag-firing-list">
                {top5.map(([fid, n]) => (
                    <li key={fid}>
                        <span className="flag-id">{fid}</span>
                        <span className="flag-count">{n}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
}
